import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SeismicDivisionDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-seismicdivision',
  templateUrl: './seismicdivision.component.html',
  styleUrls: ['./seismicdivision.component.scss']
})
export class SeismicDivisionComponent implements OnInit {


  seismicdivisionForm: FormGroup;
  seismicdivisionFormArray: FormGroup;
  control = new FormControl();
  @Input() seismicdivisions: SeismicDivisionDto[];
  @Input() routeAnimationsElements: any;
  @Output() seismicdivision = new EventEmitter<SeismicDivisionDto[]>()
  @Output() deleteSeismicDivisionEvent = new EventEmitter<any>()

    selectedSeismicDivision: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnInit() {
      this.createSeismicDivisionForm();
    }

    createSeismicDivisionForm() {
      this.seismicdivisionForm = this.fb.group({
        DivisionName: ['', Validators.required],
        id: null
        });
        this.seismicdivisionFormArray = this.fb.group({ SeismicDivisions: this.fb.array([])
          });
          if(this.seismicdivisions != null && this.seismicdivisions.length) {
            this.setSeismicDivision();
          }
        
    }

  // method to display seismicdivisions
  setSeismicDivision() {
    const control  = this.seismicdivisionFormArray.controls.SeismicDivisions as FormArray;
    this.seismicdivisions.forEach( e => {
      control.push(
        this.fb.group({
        DivisionName: e.DivisionName,
          id: e.id
        })
      );
    });
  }


  // method to add SeismicDivision
  addSeismicDivision(value: SeismicDivisionDto) {
    const control  = this.seismicdivisionFormArray.controls.SeismicDivisions as FormArray;
    control.insert(0,
          this.fb.group({
            DivisionName: value.DivisionName,
            id: null
          })
       );
  }

  selectSeismicDivision(value) {}

  // method to delete seismicdivision from arrary list
  deleteSeismicDivision(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.seismicdivisionFormArray.controls.SeismicDivisions as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.seismicdivisions.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.seismicdivisions[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: SeismicDivisionDto) {
    if(this.seismicdivisionForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.seismicdivisionFormArray.get('SeismicDivisions')['controls'][this.selectedIndex].patchValue({DivisionName: formValue.DivisionName});
    } else {
      this.addSeismicDivision(formValue);
    }
    this.selectedIndex = null;
    this.seismicdivisionForm.reset()
  }

  onEdit(index, value: SeismicDivisionDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.seismicdivisionForm.patchValue({DivisionName: value.DivisionName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.seismicdivisionForm.reset();
  }

  onSubmit(formValue: SeismicDivisionDto[]) {
  this.seismicdivision.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteSeismicDivisionEvent.emit(this.filteredDelete);
  }
  }

}
